export enum QuoteFileSource {
  BOM_IMPORT = 'bom_import',
  DOWNLOAD = 'quote_download',
  OUTLOOK_IMPORT = 'outlook_import',
  SPA_SENT = 'spa_sent',
  UPLOAD = 'upload',
  VENDOR_QUOTE_IMPORT = 'vendor_quote_import',
}
